import React, { useRef, useState, useEffect } from 'react';
import './Tabs.css';

const Tabs = ({ tabs, activeTab, setActiveTab, tableRefs, className }) => {
    const openTab = (tabName) => {
        setActiveTab(tabName);
    };

    const tabsWrapperRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const checkScroll = () => {
        if (tabsWrapperRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = tabsWrapperRef.current;
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
        }
    };

    useEffect(() => {
        checkScroll();
        window.addEventListener('resize', checkScroll);
        const wrapper = tabsWrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener('scroll', checkScroll);
        }
        return () => {
            window.removeEventListener('resize', checkScroll);
            if (wrapper) {
                wrapper.removeEventListener('scroll', checkScroll);
            }
        };
    }, []);

    const scrollTabs = (direction) => {
        if (tabsWrapperRef.current) {
            const scrollAmount = direction === 'left' ? -200 : 200;
            tabsWrapperRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    return (
        <div className={`tabs-container ${className || ''}`}>
            <div className="tabs-navigation">
                <button
                    className={`tab-arrow tab-arrow-left ${showLeftArrow ? 'visible' : ''}`}
                    onClick={() => scrollTabs('left')}
                    aria-hidden={!showLeftArrow}
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 12L6 8L10 4" stroke="#5B965D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="tabs-wrapper" ref={tabsWrapperRef}>
                    <div className="tabs">
                        {tabs.map((tab) => (
                            <a
                                key={tab.name}
                                href="#"
                                className={`tab__link ${activeTab === tab.name ? 'tab__link--active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    openTab(tab.name);
                                }}
                            >
                                {tab.label}
                            </a>
                        ))}
                    </div>
                </div>
                <button
                    className={`tab-arrow tab-arrow-right ${showRightArrow ? 'visible' : ''}`}
                    onClick={() => scrollTabs('right')}
                    aria-hidden={!showRightArrow}
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12L10 8L6 4" stroke="#5B965D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
            <div className="tab-content">
                {tabs.map((tab) => (
                    <div
                        key={tab.name}
                        id={tab.name}
                        className={`tabcontent ${activeTab === tab.name ? 'active' : ''}`}
                        ref={(el) => (tableRefs.current[tab.name] = el)}
                    >
                        {tab.content}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tabs;